import { UnallocatedJobDto } from '@app/models/job.model';

export interface UnallocatedJobRow {
  readonly id: string;
  readonly siteId: string;
  readonly companyId: string | null;
  readonly brandName: string | null;
  readonly siteName: string | null;
  readonly referenceNumber: string | null;
  readonly calloutDate: string | null;
  readonly faultServiceName: string | null;
  readonly notes: string | null;
  readonly workOrderNumber: string | null;
}

export function mapUnallocatedJob(dto: UnallocatedJobDto): UnallocatedJobRow {
  return {
    id: dto.id,
    siteId: dto.siteId,
    companyId: dto.companyId,
    brandName: dto.site?.brand?.name ?? null,
    siteName: dto.site?.name ?? null,
    referenceNumber: dto.referenceNumber,
    calloutDate: dto.latestJobEvent?.bookedOnUtc ?? null,
    faultServiceName: dto.faultServiceName,
    notes: dto.notes,
    workOrderNumber: dto.workOrderNumber
  };
}
